import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// You can import config values from a separate file
import authConfig from "./authConfig";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <Auth0Provider
    domain={authConfig.domain}
    clientId={authConfig.clientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: authConfig.audience // optional
    }}
  >
    <App />
  </Auth0Provider>
);

// Register service worker for PWA functionality
// serviceWorkerRegistration.register();
